/*
 * Cart drawer "Others also bought" recommendations.
 *
 * The <cart-recommendations> element lives in the cart drawer with a
 * data-base-product-id (a representative cart item). On connect it fetches the
 * cart-recommendations section rendered for that product and injects the cards.
 * Because the cart drawer re-renders its inner HTML on every change, this
 * element is recreated each time and refreshes itself automatically.
 */
(function () {
  // Cache rendered markup by request URL to avoid a flash on quantity changes
  // (same base product => same URL => instant). Cleared after an add so a newly
  // added product drops out of the list.
  const cache = new Map();

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      const baseId = this.dataset.baseProductId;
      if (!baseId) return;

      const endpoint = this.dataset.url || '/recommendations/products';
      const intent = this.dataset.intent || 'related';
      const limit = this.dataset.limit || '10';
      const url = `${endpoint}?section_id=cart-recommendations&product_id=${baseId}&intent=${intent}&limit=${limit}`;

      if (cache.has(url)) {
        this.innerHTML = cache.get(url);
        return;
      }

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('.cart-recommendations__inner');
          const markup = inner ? inner.outerHTML : '';
          cache.set(url, markup);
          this.innerHTML = markup;
        })
        .catch((error) => {
          console.error('Cart recommendations failed to load', error);
          this.innerHTML = '';
        });
    }
  }

  if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
  }

  // Add a recommended product to the cart and re-render the drawer.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.cart-rec__add');
    if (!button || button.hasAttribute('disabled')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [];

    button.setAttribute('disabled', '');
    cache.clear(); // recommendations will change once this product is in the cart

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (cartDrawer && data.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch((error) => {
        console.error('Add recommendation failed', error);
        window.location.href = '/cart';
      })
      .finally(() => {
        button.removeAttribute('disabled');
      });
  });
})();
